import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import { getGrantees } from "../../core/service/grantees.service";
import { getProgressReportApprovalList } from "../../core/service/progressReport.service";

// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 340,
  marginTop: theme.spacing(5) - 10,
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

const formatDataArray = (arr) => {
  const ListGranteesId = arr.grantees.reduce((acc, grantee) => {
    acc.push(grantee.user_id);
    return acc;
  }, []).length;

  const ListReportsId = [
    ...new Set(
      arr.reports.reduce((acc, report) => {
        acc.push(report.user_id);
        return acc;
      }, [])
    )
  ].length;

  return {
    total_listGrantees: ListGranteesId || 0,
    total_listReport: ListReportsId || 0
  };
};

export default function PostdocGranteeProgressChartMentor() {
  const [granteesAndReport, setGranteesAndReport] = useState({});
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const getGranteesAndReport = async () => {
    const data = await getGrantees(id);
    const dataReport = await getProgressReportApprovalList(id);
    const { entities: grantees } = data;
    const { entities: reports } = dataReport;

    const toFormat = {
      grantees: grantees.filter((e) => e.role_id === 1),
      reports: reports.filter((e) => e.role_id === 1)
    };

    const res = formatDataArray(toFormat);
    setGranteesAndReport(res);
  };
  useEffect(() => {
    getGranteesAndReport();
  }, []);

  const dataToChart = (
    (granteesAndReport?.total_listReport * 100) /
    granteesAndReport?.total_listGrantees
  ).toFixed(2);
  const CHART_DATA = [dataToChart || 0];

  const chartOptions = {
    colors: ["#0070C0"],
    labels: ["Progress"],
    legend: { show: false },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val;
      },
      dropShadow: { enabled: true }
    },
    plotOptions: {
      radialBar: { hollow: { size: "50%" } }
    }
  };

  return (
    <Card>
      <CardHeader title="Postdoc Grantee Progress" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radialBar"
          series={CHART_DATA}
          options={chartOptions}
          height={360}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
